// The organisation's team: seats, members, invitations, roles (V4Equipe).
export default {
  titre: 'Team',
  chargement: 'Loading…',
  fermer: 'Close',
  acces: {
    administrateur: 'Administrator',
    role: 'Role',
    personnalise: 'Custom access',
  },
  niveau: {
    analyst: 'Runs studies',
    viewer: 'View only',
  },
  gereEquipe: 'Manages the team',
  panneau: {
    inviter: 'Invite someone',
    creerRole: 'Create a role',
    envoyee: 'Invitation sent',
    prete: 'Invitation ready',
    // The invitation in two steps (October 15, 2026).
    pas: {
      qui: 'Who',
      acces: 'Their access',
    },
  },
  erreur: {
    choisirRole: 'Choose a role.',
    email: 'A full email address, for example first.last@example.com.',
  },
  annonce: {
    accesMisAJour: 'Access updated.',
    roleCree: 'Role created.',
    roleMisAJour: 'Role updated.',
    retire: '{email} is no longer on the team.',
    invitationRetiree: 'Invitation withdrawn.',
    roleSupprime: 'Role deleted.',
    lienCopie: 'Link copied.',
    copieImpossible: 'Could not copy: select the link.',
  },
  confirmer: {
    retirer: 'Remove {email} from the team? Their seat will be freed.',
    retirerInvitation: 'Withdraw the invitation for {email}? Its link will stop working.',
    supprimerRole: 'Delete the role “{nom}”?',
    titre: {
      retirer: 'Remove this member',
      retirerInvitation: 'Withdraw the invitation',
      supprimerRole: 'Delete the role',
    },
    bouton: {
      retirer: 'Remove',
      supprimer: 'Delete',
    },
  },
  sieges: {
    titre: 'Seats',
    sur: 'of {n}',
    inviter: 'Invite',
    complet: 'All seats are taken',
  },
  membres: {
    titre: 'Members',
    vous: 'You',
    equipeOrion: 'Orion team',
    derniereConnexion: 'Last signed in on {date}',
    aucuneConnexion: 'Never signed in',
    aucunModule: 'No modules',
    modifier: 'Edit',
    retirer: 'Remove from the team',
    personne: 'Nobody yet.',
  },
  invitations: {
    expire: 'Link expired',
    du: 'Invited on {date}',
    nouveauLien: 'New link',
    retirer: 'Withdraw the invitation',
  },
  roles: {
    titre: 'Roles',
    creer: 'Create a role',
    personnes: '{n} people | {n} person | {n} people',
    supprimer: 'Delete the role',
    aucun: 'No roles.',
  },
  lien: {
    emailParti: 'An email has been sent to',
    envoyez: 'Send this link to',
    copier: 'Copy the link',
    valable: 'Valid until {date}.',
  },
  formulaire: {
    email: 'Email address',
    emailExemple: "firstname.lastname{'@'}example.com",
    acces: 'Access',
    peutLancer: 'Can run studies',
    unInstant: 'One moment…',
    inviter: 'Invite',
    enregistrer: 'Save',
    nomRole: 'Role name',
    nomRoleExemple: 'Projector analyst',
    modules: 'Modules',
    creerRole: 'Create the role',
  },
}
